import { useEffect, useRef } from "react";

const CW = 192, CH = 72;
const R = (c, col, x, y, w, h) => { c.fillStyle = col; c.fillRect(Math.round(x), Math.round(y), w, h); };

function cabinScene(c, t) {
  R(c, "#04070f", 0, 0, CW, CH);
  for (let s = 0; s < 60; s++) R(c, "#0b1424", s * 2, 22 + Math.abs(s - 30) * 0.9, 2, CH);
  for (let s = 0; s < 50; s++) R(c, "#0d182a", 96 + s * 2, 26 + Math.abs(s - 25) * 1.1, 2, CH);
  R(c, "#a9bbcc", 54, 22, 12, 1); R(c, "#a9bbcc", 142, 26, 10, 1);
  [12, 26, 152, 168, 182].forEach((x) => { R(c, "#05080f", x + 3, 44, 2, 14); for (let k = 0; k < 3; k++) R(c, "#08101c", x + 4 - (2 + k * 2), 34 + k * 5, 4 + k * 4, 5); R(c, "#d9e4ee", x + 2, 34, 4, 1); });
  R(c, "#c8d6e3", 0, 58, CW, CH - 58); R(c, "#8ea4bb", 0, 57, CW, 1);
  const x = 72;
  R(c, "#1e150d", x, 40, 44, 18); for (let y = 42; y < 58; y += 4) R(c, "#140e08", x, y, 44, 1);
  for (let i = 0; i < 7; i++) R(c, "#1e150d", x - 3 + i * 3, 40 - i * 2, 50 - i * 6, 2);
  R(c, "#d9e4ee", x - 4, 39, 52, 2); R(c, "#d9e4ee", x + 12, 27, 24, 2);
  R(c, "#2a1a10", x + 32, 28, 5, 10);
  for (let i = 0; i < 4; i++) R(c, `rgba(120,130,145,${0.4 - i * 0.08})`, x + 33 + Math.sin(t / 700 + i) * 2 - i, 24 - i * 5 - ((t / 90) % 5), 3, 3);
  const on = Math.sin(t / 400) > -0.92;
  R(c, on ? "#f59e0b" : "#7c4a06", x + 7, 46, 6, 6); R(c, "#f59e0b", x + 31, 46, 6, 6); R(c, "#3a2414", x + 19, 48, 6, 10);
  R(c, "rgba(245,158,11,0.18)", x + 4, 58, 36, 3);
  for (let i = 0; i < 40; i++) R(c, "#e8f1ff", (i * 47.3 + t * 0.006) % CW, (i * 23.1 + t * 0.012) % CH, 1, 1);
  if (Math.sin(t / 1300) > 0.97) R(c, "#dc2626", 160, 52, 1, 1);
}

function wolfScene(c, t) {
  R(c, "#03050b", 0, 0, CW, CH);
  for (let s = 0; s < 96; s++) R(c, "#080f1c", s * 2, 18 + Math.abs(((s * 3) % 70) - 35) * 0.6, 2, CH);
  for (let y = -4; y <= 4; y++) { const h = Math.round(Math.sqrt(16 - y * y)); R(c, "#cfd8e3", 164 - h, 12 + y, h * 2, 1); R(c, "#03050b", 167 - h, 11 + y, h * 2, 1); }
  [8, 30, 140, 170, 186].forEach((x, i) => { R(c, "#05080f", x + 3, 30, 2, 28); for (let k = 0; k < 4; k++) R(c, "#070c16", x + 4 - (2 + k * 2), 14 + k * 6 + (i % 2) * 3, 4 + k * 4, 7); R(c, "#9fb3c7", x + 2, 14 + (i % 2) * 3, 4, 1); });
  R(c, "#c8d6e3", 0, 58, CW, CH - 58); R(c, "#8ea4bb", 0, 57, CW, 1);
  const glow = c.createRadialGradient(92, 40, 4, 92, 40, 70);
  glow.addColorStop(0, "rgba(120,145,175,0.55)"); glow.addColorStop(1, "rgba(120,145,175,0)");
  c.fillStyle = glow; c.fillRect(20, 0, 150, 58);
  c.save(); c.translate(92, 58); c.scale(1.2, 1.2); c.translate(-92, -58);
  const b = Math.round(Math.sin(t / 1400)), D = "#04060a", L = "#6b7f99";
  const WOLF = [[40, 33], [48, 30], [53, 26], [55, 18], [58, 24], [61, 18], [63, 25], [70, 26], [80, 28], [96, 29], [112, 30], [124, 31], [130, 34],
    [138, 40], [143, 48], [140, 50], [133, 43], [127, 40], [125, 47], [123, 58], [119, 58], [118, 48], [110, 44], [98, 45], [86, 45],
    [83, 58], [79, 58], [77, 46], [70, 44], [63, 40], [55, 37], [45, 36], [40, 35]];
  const poly = (col, dy) => { c.fillStyle = col; c.beginPath(); WOLF.forEach(([x, y], k) => (k ? c.lineTo(x, y + (k > 6 && k < 13 ? b : 0) + dy) : c.moveTo(x, y + dy))); c.fill(); };
  poly(L, -1); poly(D, 0);
  R(c, D, 88, 45, 4, 13); R(c, D, 112, 46, 4, 12);
  if (Math.sin(t / 1700) > 0.55) { R(c, "#f59e0b", 50, 29, 2, 1); R(c, "rgba(245,158,11,0.3)", 49, 28, 4, 3); }
  for (let i = 0; i < 3; i++) { const p = ((t / 1600) + i / 3) % 1; R(c, `rgba(200,214,227,${0.35 * (1 - p)})`, 38 - p * 14, 33 - p * 5, 3 + p * 4, 2 + p * 2); }
  c.restore();
  [[86, 3], [108, 4], [150, 3]].forEach(([x, w]) => { R(c, "#04060a", x, 0, w, 58); R(c, "#1c2636", x + w - 1, 0, 1, 58); });
  R(c, "#e8f1ff", 30, 58, 50, 1); for (let i = 0; i < 9; i++) R(c, "#b9cddd", 60 + i * 7, 60 + (i % 2), 3, 1);
  for (let i = 0; i < 46; i++) R(c, "#e8f1ff", (i * 47.3 + t * 0.006) % CW, (i * 23.1 + t * 0.013) % CH, 1, 1);
}

function altarScene(c, t) {
  R(c, "#050304", 0, 0, CW, CH);
  const fl = 0.85 + Math.sin(t / 110) * 0.08 + Math.sin(t / 47) * 0.05;
  const g = c.createRadialGradient(96, 44, 6, 96, 44, 95);
  g.addColorStop(0, `rgba(245,140,40,${0.4 * fl})`); g.addColorStop(0.5, `rgba(150,40,20,${0.18 * fl})`); g.addColorStop(1, "rgba(0,0,0,0)");
  c.fillStyle = g; c.fillRect(0, 0, CW, CH);
  for (let x = 0; x < CW; x += 6) { const h = 4 + ((x * 37) % 13); R(c, "#120c0a", x, 0, 6, h); R(c, "#120c0a", x + 2, h, 2, 3 + (x % 5)); }
  for (let y = 0; y < CH; y += 6) { R(c, "#110b09", 0, y, 22 + ((y * 13) % 9), 6); R(c, "#110b09", CW - 22 - ((y * 7) % 9), y, 30, 6); }
  R(c, "#1a1210", 0, 60, CW, CH - 60); R(c, "#2a1d17", 0, 60, CW, 1);
  R(c, "#2a2420", 70, 48, 52, 12); R(c, "#3a322c", 68, 46, 56, 3); R(c, "#1a1512", 74, 51, 44, 1);
  R(c, "#4a1010", 92, 52, 8, 1); R(c, "#4a1010", 92, 52, 1, 6); R(c, "#4a1010", 99, 52, 1, 6); R(c, "#4a1010", 92, 57, 8, 1); R(c, "#7f1d1d", 95, 54, 2, 2);
  R(c, "#6b0f0f", 110, 49, 1, 2 + Math.round((t / 600) % 6)); R(c, "#6b0f0f", 80, 49, 1, 4);
  const sw = Math.round(Math.sin(t / 900));
  c.save(); c.translate(96, 46); c.scale(1.05, 1.05); c.translate(-96, -42);
  R(c, "#5c0f0f", 90 + sw, 22, 12, 20); R(c, "#7f1d1d", 92 + sw, 22, 7, 20); R(c, "#5c0f0f", 88 + sw, 36, 16, 6);
  R(c, "#5c0f0f", 92 + sw, 13, 8, 10); R(c, "#7f1d1d", 93 + sw, 13, 5, 3); R(c, "#050203", 94 + sw, 16, 4, 5);
  R(c, "#5c0f0f", 99 + sw, 12, 3, 12); R(c, "#d9b48f", 100 + sw, 10, 2, 2);
  R(c, "#3a2414", 100 + sw, 8, 2, 2); R(c, "#cfd8e3", 100 + sw, 1, 2, 7); R(c, "#94a3b8", 99 + sw, 7, 4, 1); R(c, "#ffffff", 100 + sw, 1, 1, Math.sin(t / 700) > 0.6 ? 7 : 2);
  R(c, "#a33", 102 + sw, 12, 1, 10); c.restore();
  [[30, 58, 4], [44, 60, 3], [62, 45, 2], [128, 45, 3], [146, 60, 4], [160, 58, 3], [24, 30, 3], [168, 32, 2], [80, 60, 2], [114, 60, 3]].forEach(([x, y, n], k) => {
    for (let i = 0; i < n; i++) { const h = 3 + ((k + i) * 3) % 4, cx = x + i * 4; R(c, "#7f1d1d", cx, y - h, 2, h); R(c, Math.sin(t / 70 + k + i) > 0 ? "#fde047" : "#f97316", cx, y - h - 2, 1, 2); }
  });
  for (let i = 0; i < 14; i++) R(c, "rgba(253,186,116,0.6)", (i * 53.7) % CW, CH - ((i * 31 + t * 0.008) % CH), 1, 1);
}

const SCENES = { 1: cabinScene, 2: wolfScene, 3: altarScene };

export const ChapterArt = ({ chapter = 1 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current.getContext("2d"); let raf;
    const scene = SCENES[chapter];
    const loop = (t) => { scene(c, t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [chapter]);
  return <canvas ref={ref} width={CW} height={CH} className="w-full h-auto block border-2 border-[#2E3440] mt-5" style={{ imageRendering: "pixelated" }} data-testid={`chapter-${chapter}-art`} />;
};
